export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00998.ce909af6.png";